import {Box, Button, makeStyles} from "@material-ui/core";
import {useEffect} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    marginTop: 10,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
    },
  },
  description: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: (props: any) => (props.width < 1090 || props.height < 770) ? 22 : 24,
    fontFamily: 'roboto-light',
    '& p': {
      margin: 0,
      maxWidth: 1000,
      color: '#212D40',
      textAlign: 'center',
      lineHeight: 1.25,
    },
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  },
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    width: 300,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 600px)': {
      width: 'auto',
      height: 'auto',
      padding: '3px 12px',
      fontSize: 11,
    },
  },
  img: {
    width: (props: any) => props.height < 770 ? 300 : 400,
    height: 'auto',
    margin: '30px 0'
  }
}));

const Module4Slide1 = () => {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm4s1');
  }, []);

  const onShowResult = () => {
    if (Number(activepage.value) < 15) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '15',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(15))
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div className={classes.title}>
        Welcome to Module 4! (You’re almost finished)
      </div>
      <div className={classes.description}>
        Now you’ll view and analyze the results of the video you measured.
      </div>
      <img className={classes.img} src={'/assets/icons/onboarding/module4-slide1.svg'} alt={'Image'} />
      <div className={classes.description}>
        <p>
          Follow the tour to discover some of the most simple and powerful ways to use the Immersion
          platform. If you have questions, we’ll be happy to answer them during your Data Debrief.
        </p>
      </div>
      <Box mt={2} mb={1} display='flex' flexDirection='row' alignItems='center' justifyContent='center' style={{ position: 'relative' }}>
        <Button color='primary' size='large' className={classes.btn} onClick={onShowResult}>
          Show Me Some Results!
        </Button>
      </Box>
    </div>
  )
};

export default Module4Slide1;